<div class="custom-scrollbar-css">
    <h2 class="modal-title"> Historique de calibration </h2>
    <ngx-spinner *ngIf="Calibration_DataSource?.data?.length !=0 "  bdColor = "rgba(100,112,124,0.56)" size = "medium" color = "#233547" type = "ball-clip-rotate-multiple" [fullScreen] = "false"><p style="color: white" > </p></ngx-spinner>

    <div class="example-container2 mat-elevation-z8  p-2  ">
        <table mat-table matSort [dataSource]="Calibration_DataSource">

            <!-- Date Column -->
            <ng-container matColumnDef="timestamp">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                <td  mat-cell *matCellDef="let element"> {{element.timestamp}} </td>
            </ng-container>

            <!-- Statut_calibration Column -->
            <ng-container  matColumnDef="calibration">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut de calibration </th>
                <td   mat-cell *matCellDef="let element"> {{element.calibration}} </td>
            </ng-container>

           


            <tr  mat-header-row *matHeaderRowDef="Calibration_DisplayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: Calibration_DisplayedColumns;"></tr>
        </table>
    </div>

</div>